<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">短信任务</div>

      <div class="search-wrapper">
         <el-form :inline="true" v-model="formParam">
            <el-form-item label="名称">
               <el-input placeholder="请输入名称" v-model="formParam.name">
               </el-input>
            </el-form-item>
            <el-form-item label="时间">
               <el-date-picker placeholder="请选择查询时间" type='daterange' v-model="formParam.timeRange" clearable>
               </el-date-picker>
            </el-form-item>
            <el-form-item label="状态">
               <el-select placeholder="请选择状态" v-model="formParam.status">
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option label="未发布" :value="0"></el-option>
                  <el-option label="进行中" :value="1"></el-option>
                  <el-option label="已结束" :value="2"></el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <el-button type="primary" @click="queryList">搜索</el-button>
         <el-button @click="clickReset">重置</el-button>
      </div>

      <div class="action-wrapper">
         <el-button type="primary" @click="clickAddition">新增</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="tableData">
            <el-table-column align="center" label="序号" prop="id" width="80"></el-table-column>
            <el-table-column align="center" label="任务名称" prop="taskName"></el-table-column>
            <el-table-column align="center" label="时间" prop="date">
               <template scope="{ row }">
                  {{ $util.dateFormat(new Date(row.date), 'yyyy-MM-dd hh:mm:ss') }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
               <template scope="{ row }">
                  <div v-if="row.status === 0">未发布</div>
                  <div v-if="row.status === 1">进行中</div>
                  <div v-if="row.status === 2">已结束</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180">
               <template scope="{ row }">
                  <el-button v-if="row.status === 0" type="text" @click="clickPublish(row)">发布</el-button>
                  <el-button v-if="row.status === 0" type="text" @click="clickEditing(row)">编辑</el-button>
                  <el-button v-if="row.status !== 0" type="text" @click="clickDetail(row)">详情</el-button>
                  <el-button v-if="row.status === 0" type="text" style="color: red"
                     @click="clickDelete(row)">删除</el-button>
               </template>
            </el-table-column>
         </el-table>

         <div class="pagination-wrapper">
            <el-pagination v-show="totalCount > 0" layout="prev, pager, next, jumper" :current-page="formParam.pageNum"
               :page-size='formParam.pageSize' :total="totalCount" @current-change="changeCurrentPage">
            </el-pagination>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         formParam: {
            name: "",
            timeRange: [],
            status: -1,
            pageNum: 1,
            pageSize: 10
         },
         statusOptions: ["全部", "开启", "关闭"],
         tableData: [],
         totalCount: 0
      }
   },

   mounted() {
      this.queryList();
   },

   methods: {
      // 查询列表
      queryList() {
         this.loading = true;
         let startTime = this.formParam.timeRange[0] ? new Date(this.formParam.timeRange[0]).getTime() : '';
         let endTime = this.formParam.timeRange[1] ? new Date(this.formParam.timeRange[1]).getTime() : '';
         this.$http({
            url: this.$util.domain + '/adminapi/v61200/sms/task/page',
            method: 'POST',
            body: JSON.stringify({
               name: this.formParam.name,
               startTime: startTime,
               endTime: endTime,
               status: this.formParam.status === -1 ? undefined : this.formParam.status,
               pageNum: this.formParam.pageNum,
               pageSize: this.formParam.pageSize
            })
         }).then(response => {
            if (response.data.error === 10000) {
               let data = response.data.data;
               if (data.count) {
                  this.tableData = data.data;
                  this.totalCount = data.count;
               } else {
                  this.tableData = [];
                  this.totalCount = 0;
               }
            }
         }).catch(() => {
            this.$util.errorMsg('获取列表失败');
         }).finally(() => {
            this.loading = false;
         })
      },

      // 发送短信
      sendSMS(id) {
         this.loading = true;
         this.$http({
            url: this.$util.domain + "/adminapi/v61200/sms/task/publish",
            method: "GET",
            params: { id }
         }).then((res) => {
            if (res.data.error === 10000) {
               this.$util.successMsg('发布成功');
               this.queryList();
            } else {
               this.$util.errorMsg(res.data.message);
            }
         }).catch((error) => {
            this.$util.errorMsg('发布失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 删除短信
      deleteSMS(id) {
         this.loading = true;
         this.$http({
            url: this.$util.domain + "/adminapi/v61200/sms/task/delete",
            method: "GET",
            params: { id }
         }).then((res) => {
            if (res.data.error === 10000) {
               this.$util.successMsg('删除成功');
               this.queryList();
            } else {
               this.$util.errorMsg(res.data.message);
            }
         }).catch((error) => {
            this.$util.errorMsg('删除失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 点击重置
      clickReset() {
         this.formParam = {
            name: "",
            timeRange: [],
            status: -1,
            pageNum: 1,
            pageSize: 10
         }
      },

      // 点击添加
      clickAddition() {
         this.$router.push({
            path: '/yunying/sms/task/edit',
         });
      },

      // 点击发布
      clickPublish(row) {
         this.sendSMS(row.id);
      },

      // 点击编辑
      clickEditing(row) {
         this.$util.setStore('smsTaskRow', row);
         this.$router.push({
            path: '/yunying/sms/task/edit',
         });
      },

      // 点击详情
      clickDetail(row) {
         this.$util.setStore('smsTaskRow', row);
         this.$router.push({
            path: '/yunying/sms/task/detail',
            query: { id: row.id }
         });
      },

      // 点击删除
      clickDelete(row) {
         this.$confirm('是否确定删除？', '温馨提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning'
         }).then(() => {
            this.deleteSMS(row.id);
         }).catch(() => { });
      },

      // 切换页码
      changeCurrentPage(val) {
         this.formParam.pageNum = val;
         this.queryList();
      }
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// SMSTask.vue?31f3dffc